module.exports = __webpack_public_path__ + "img/P12.f07f5bfc.png";